export const lexicalTheme = {
  paragraph: 'LexicalRichHtmlInput-paragraph',
  text: {
    bold: 'LexicalRichHtmlInput-textBold',
    italic: 'LexicalRichHtmlInput-textItalic',
    strikethrough: 'LexicalRichHtmlInput-textStrikethrough',
  },
  link: 'LexicalRichHtmlInput-link',
  list: {
    ul: 'LexicalRichHtmlInput-listUl',
    ol: 'LexicalRichHtmlInput-listOl',
    listitem: 'LexicalRichHtmlInput-listItem',
    nested: {
      list: 'LexicalRichHtmlInput-nestedList',
      listitem: 'LexicalRichHtmlInput-nestedListItem',
    },
  },
}
